<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="controller">
    <v-row class="max-w">
      <v-col cols="12">
        <v-form
          ref="form"
          v-model="valid"
          class="mx-4"
        >
          <div class="headline font-weight-bold text--primary mb-8 w-80">
            {{ $t('Edycja-sterownika') }}
          </div>
          
          <v-text-field
          v-model="displayName"
          :rules="displayNameRules"
          :label="$t('display-name')"
          required
          ></v-text-field>


          <div class="text-center mt-8">
            <v-btn 
            :loading="saving"
            :disabled="saving" 
            @click="postForm"
            x-large class="w-100" color="primary">{{ $t('zapisz') }}</v-btn>

          <v-btn text x-large @click="$router.go(-1)" class="w-100 mt-2">
            {{ $t('anuluj') }}
          </v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data: () => ({
    valid: true,
    displayName: '',
    displayNameRules: [
      v => !!v || 'Podaj własną nazwę sterownika',
      v => (v && v.length > 2 && v.length <26) || 'Nazwa sterownika musi mieć od 3 do 25 znaków'
    ],
    saving: false,
    success: false
  }),
  computed: {
    ...mapGetters([
      'token', 'controllerById'
    ]),
    controllerId() {
      return this.$route.params.controllerId
    },
    controller() {
      return this.controllerById(this.controllerId)
    }
  },
  methods: {
    ...mapActions([
      'updateController',
      'syncControllers'
    ]),
    postForm () {
      this.saving = true;
      
      const formData = new URLSearchParams();
      formData.append('controllerId', this.controllerId);
      formData.append('displayName', this.displayName);
      formData.append('token', this.token);

      this.updateController(formData)
      .then(res => {
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
          this.saving = false;
        } else {
          this.syncControllers(true).then(res => {
            this.saving = false;
            this.$router.push({ path: '/controller/' + this.controllerId });
          })
        }
      });
    }
  },
  created () {
    this.displayName = this.controller.displayName;
  }
}
</script>

<style>
</style>

